if (!customElements.get('variant-package-contents')) {
  customElements.define(
    'variant-package-contents',
    class VariantPackageContents extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.stage = this.querySelector('[data-variant-package-stage]');
        this.variantIds = new Set(
          (this.dataset.variantIds || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean)
        );

        document.addEventListener('variant:change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal,
        });

        this.showVariant(this.getAttribute('selected-variant-id'), true);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onVariantChange(event) {
        const variantId = event.detail?.variant?.id;
        if (!variantId) return;

        const normalizedId = String(variantId);
        if (!this.variantIds.has(normalizedId)) return;

        this.showVariant(normalizedId);
      }

      showVariant(variantId, preserveServerRender = false) {
        if (!this.stage || !variantId) return;

        const normalizedId = String(variantId);
        const currentPanel = this.stage.querySelector('[data-variant-package-panel]');

        if (
          preserveServerRender &&
          currentPanel &&
          currentPanel.dataset.variantId === normalizedId
        ) {
          this.hidden = false;
          return;
        }

        const template = Array.from(this.querySelectorAll('template[data-variant-package-template]')).find(
          (candidate) => candidate.dataset.variantPackageTemplate === normalizedId
        );
        const fallbackTemplate = this.querySelector('template[data-variant-package-fallback]');
        const selectedTemplate = template || fallbackTemplate;

        if (!selectedTemplate) {
          this.stage.replaceChildren();
          this.hidden = true;
          this.setAttribute('selected-variant-id', normalizedId);
          return;
        }

        this.stage.replaceChildren(selectedTemplate.content.cloneNode(true));
        this.hidden = false;
        this.setAttribute('selected-variant-id', normalizedId);
      }
    }
  );
}
